<template>
  <v-container fluid>

    <v-row justify="center">
      <v-col cols="12">
        <h1>アカウント所属変更</h1>
      </v-col>
    </v-row>

    <!-- エラー -->
    <v-row justify="center" v-if="view.errors.length > 0">
      <v-col cols="12">
        <mp-error :errors="view.errors" :replaceList="errMessageReplaceList" message-key="message.admin.accountchangegroup.error." />
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4" offset="4">
        <mp-label>現所属</mp-label>
      </v-col>
      <v-col cols="4">
        <mp-label>変更先所属</mp-label>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>グループ分類<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="4" outlined tile>
        <mp-input-box min>
          <v-select
            v-model="form.befor.groupSmallId"
            :items="view.groupList"
            item-text="text"
            item-value="value"
            label="選択してください"
            hide-details
            solo
            dense
            color="green"
            item-color="green"
          ></v-select>
        </mp-input-box>
      </v-col>
      <v-col cols="4" outlined tile>
        <mp-input-box min>
          <v-select
            v-model="form.after.groupSmallId"
            :items="view.groupList"
            item-text="text"
            item-value="value"
            label="選択してください"
            hide-details
            solo
            dense
            color="green"
            item-color="green"
          ></v-select>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>会社<span v-if="!view.after.isCompanyDisable" class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="4" outlined tile>
        <mp-input-box min>
          <v-autocomplete
            v-model="form.befor.companyId"
            :items="view.befor.companyList"
            item-text="text"
            item-value="value"
            label="選択してください"
            hide-details
            solo
            dense
            color="green"
            item-color="green"
            :disabled="view.befor.isCompanyDisable"
          ></v-autocomplete>
        </mp-input-box>
      </v-col>
      <v-col cols="4" outlined tile>
        <mp-input-box min>
          <v-autocomplete
            v-model="form.after.companyId"
            :items="view.after.companyList"
            item-text="text"
            item-value="value"
            label="選択してください"
            hide-details
            solo
            dense
            color="green"
            item-color="green"
            :disabled="view.after.isCompanyDisable"
          ></v-autocomplete>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>支社・支局／媒体</mp-label>
      </v-col>
      <v-col cols="4" outlined tile>
        <mp-input-box min>
          <v-autocomplete
            v-model="form.befor.branchId"
            :items="view.befor.branchList"
            item-text="text"
            item-value="value"
            label="選択してください"
            hide-details
            solo
            dense
            color="green"
            item-color="green"
            :disabled="view.befor.isBranchDisable"
          ></v-autocomplete>
        </mp-input-box>
        <div class="mt-3 text-right">
          <mp-button min @click="clearBranch('befor')">クリア</mp-button>
        </div>
      </v-col>
      <v-col cols="4" outlined tile>
        <mp-input-box min>
          <v-autocomplete
            v-model="form.after.branchId"
            :items="view.after.branchList"
            item-text="text"
            item-value="value"
            label="選択してください"
            hide-details
            solo
            dense
            color="green"
            item-color="green"
            :disabled="view.after.isBranchDisable"
          ></v-autocomplete>
        </mp-input-box>
        <div class="mt-3 text-right">
          <mp-button min @click="clearBranch('after')">クリア</mp-button>
        </div>
      </v-col>
    </v-row>

    <template v-if="search.show">
      <v-row class="mt-5" justify="center">
        <v-col cols="12">
          <h1>変更対象</h1>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="12">
          <h2>アカウント</h2>
        </v-col>
      </v-row>
      <template v-if="search.accountList.length">
        <v-row justify="space-between">
          <v-col cols="12" class="py-0">
            <div class="text-right ma-0 py-0 list-count">一覧件数：{{ search.accountList.length | addComma }}件</div>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12">
            <v-data-table
              v-model="form.selected.accountList"
              show-select
              item-key="accountId"
              :single-select="false"
              :headers="headers.account"
              :items="search.accountList"
              locale="ja-jp"
              loading-text="読込中"
              no-data-text="データがありません。"
              hide-default-footer
              mobile-breakpoint=0
              class="elevation-1"
              disable-pagination
              :items-per-page="-1"
            >
              <template v-slot:item="{ item, isSelected, select }">
                  <tr>
                    <td><v-simple-checkbox :value="isSelected" @input="select($event)" :ripple="false"></v-simple-checkbox></td>
                    <td>{{ item.mailAddress }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.groupLargeNameJp }}＞{{ item.groupSmallNameJp }}</td>
                    <td>{{ item.companyName }}<br>{{ item.branchName }}</td>
                    <td align="center">{{ item.groupAdminFlg === "1" ? '○' : ''}}</td>
                    <td align="center">{{ item.tempStopFlg === "1" ? '○' : ''}}</td>
                    <td align="center">{{ item.adminFlg === "1" ? '○' : ''}}</td>
                  </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </template>
      <v-row v-else justify="center">
        <v-col cols="12" class="pt-0">
          <div>
            検索条件に該当するアカウントは、ありません。
          </div>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="12">
          <h2>アカウント申請</h2>
        </v-col>
      </v-row>
      <template v-if="search.accountEntryList.length">
        <v-row justify="space-between">
          <v-col cols="12" class="py-0">
            <div class="text-right ma-0 py-0 list-count">一覧件数：{{ search.accountEntryList.length | addComma }}件</div>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12">
            <v-data-table
              v-model="form.selected.accountEntryList"
              show-select
              item-key="accountEntryId"
              :single-select="false"
              :headers="headers.accountEntry"
              :items="search.accountEntryList"
              locale="ja-jp"
              loading-text="読込中"
              no-data-text="データがありません。"
              fixed-header
              hide-default-footer
              mobile-breakpoint=0
              class="elevation-1"
              disable-pagination
              :items-per-page="-1"
            >
              <template v-slot:item="{ item, isSelected, select }">
                  <tr>
                    <td><v-simple-checkbox :value="isSelected" @input="select($event)" :ripple="false"></v-simple-checkbox></td>
                    <td>{{ item.entryDt }}</td>
                    <td>{{ item.mailAddress }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.groupLargeNameJp }}＞{{ item.groupSmallNameJp }}</td>
                    <td>{{ item.companyName }}<v-icon v-if="item.companyId === 0">mdi-new-box</v-icon>
                      <br>
                      {{ item.branchName !== null ? item.branchName : '' }}<v-icon v-if="item.branchId === 0">mdi-new-box</v-icon>
                    </td>
                  </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </template>
      <v-row v-else justify="center">
        <v-col cols="12" class="pt-0">
          <div>
            検索条件に該当するアカウント申請は、ありません。
          </div>
        </v-col>
      </v-row>

      <v-row v-if="isShowUpdateBtn" justify="center">
        <v-col
          class="text-center"
          cols="6"
          md="3"
        >
          <mp-button wide :disabled="isUpdateBtnDisable" :disabledBtn="isUpdateBtnDisable" @click="goUpdate">変更</mp-button>
        </v-col>
      </v-row>
    </template>
    <mp-dialog modify :show="view.dialog.updateComplete" @clickOk="clickOkUpdateComplete" />
  </v-container>
</template>

<script>
import MpLabel from '@/components/item/MpLabel.vue'
import MpButton from '@/components/item/MpButton.vue'
import MpInputBox from '@/components/item/MpInputBox.vue'
import MpDialog from '@/components/item/MpDialog.vue'
import { Common, AdminAccountChangeGroup } from '@/api'
import MpError from '@/components/item/MpError'

export default {
  name: 'AdminAccountChangeGroup',
  components: {
    MpError,
    MpLabel,
    MpButton,
    MpInputBox,
    MpDialog
  },
  data: () => ({
    companyInsNoGroupSmallIdList: [],
    view: {
      groupList: [],
      befor: {
        companyList: [],
        isCompanyDisable: true,
        isBranchDisable: true,
        branchList: []
      },
      after: {
        companyList: [],
        isCompanyDisable: true,
        isBranchDisable: true,
        branchList: []
      },
      keywordLable: {
        ja: ''
      },
      errors: [],
      dialog: {
        updateComplete: false
      }
    },
    search: {
      show: false,
      accountList: [],
      accountEntryList: []
    },
    form: {
      befor: {
        groupSmallId: null,
        companyId: null,
        branchId: null
      },
      after: {
        groupSmallId: null,
        companyId: null,
        branchId: null
      },
      selected: {
        accountList: [],
        accountEntryList: []
      }
    },
    dialog: {
      inputConfirm: false,
      registComplete: false
    },
    headers: {
      account: [],
      accountEntry: []
    },
    errMessageReplaceList: []
  }),
  computed: {
    isShowUpdateBtn () {
      return this.search.accountList.length > 0 || this.search.accountEntryList.length > 0
    },
    isUpdateBtnDisable () {
      return (this.form.selected.accountList.length === 0 && this.form.selected.accountEntryList.length === 0) || !this.isAfterSelected
    },
    isAfterSelected () {
      if (this.form.after.groupSmallId !== null) {
        if (this.companyInsNoGroupSmallIdList.includes(this.form.after.groupSmallId) || this.form.after.companyId !== null) {
          return true
        }
      }
      return false
    }
  },
  methods: {
    async goSearch () {
      this.clearSearch()
      this.clearSelected()

      const result = await AdminAccountChangeGroup.search(this.form.befor)
      this.search.accountList = result.accountList
      this.search.accountEntryList = result.accountEntryList
      this.search.show = true
    },
    async goUpdate () {
      this.errMessageReplaceList = []
      const form = {
        beforGroupSmallId: this.form.befor.groupSmallId,
        groupSmallId: this.form.after.groupSmallId,
        companyId: this.form.after.companyId,
        branchId: this.form.after.branchId,
        accountIdList: this.form.selected.accountList.map(account => account.accountId),
        accountEntryIdList: this.form.selected.accountEntryList.map(accountEntry => accountEntry.accountEntryId)
      }
      this.view.errors = []
      await AdminAccountChangeGroup.update(form)
        .then(() => { this.view.dialog.updateComplete = true })
        .catch(error => {
          this.view.errors = error.messages
          this.errMessageReplaceList = error.messages
            .filter(message => message.unavailableServices)
            .map(message => {
              return {
                param: message.param,
                pattern: '##UNAVAILABLE_SERVICE_NAMES##',
                replacement: { ja: message.unavailableServices.map(unavailableService => { return unavailableService.serviceNameJp }).join(',') }
              }
            })
        })
    },
    async changeGroupSmall (type, groupSmallId) {
      this.initialCompany(type)
      this.initialBranch(type)

      if (type === 'befor') {
        this.clearSelected()
        this.clearSearch()
      }

      if (!this.companyInsNoGroupSmallIdList.includes(groupSmallId)) {
        this.view[type].companyList = (await Common.companyList({ groupSmallId: groupSmallId }))
          .map(company => ({
            text: company.companyName,
            value: company.companyId
          }))
        this.view[type].isCompanyDisable = false
      } else {
        if (type === 'befor') {
          await this.goSearch()
        }
      }
    },
    async changeCompany (type, companyId) {
      this.initialBranch(type)
      if (companyId !== null) {
        this.view[type].branchList = (await Common.branchList({ companyId: companyId }))
          .map(branch => ({
            text: branch.branchName,
            value: branch.branchId
          }))

        this.view[type].isBranchDisable = false

        if (type === 'befor') {
          await this.goSearch()
        }
      }
    },
    async clickOkUpdateComplete () {
      this.view.dialog.updateComplete = false
      await this.goSearch()
    },
    initialCompany (type) {
      this.view[type].companyList = []
      this.form[type].companyId = null
      this.view[type].isCompanyDisable = true
    },
    initialBranch (type) {
      this.view[type].branchList = []
      this.form[type].branchId = null
      this.view[type].isBranchDisable = true
    },
    clearBranch (type) {
      this.form[type].branchId = null
    },
    clearSelected () {
      this.form.selected.accountList = []
      this.form.selected.accountEntryList = []
    },
    clearSearch () {
      this.search.show = false
      this.search.accountList = []
      this.search.accountEntryList = []
    },
    setHeaders () {
      this.headers.account = [
        { text: 'ID', value: 'mailAddress', sortable: false },
        { text: '氏名', value: 'name', sortable: false, width: 300 },
        { text: '所属', value: 'groupName', sortable: false, width: 220 },
        { text: this.view.keywordLable.ja, value: 'companyName', sortable: false, width: 200 },
        { text: '責任者', align: 'center', value: 'groupAdminFlg', sortable: false, width: 80 },
        { text: '一時停止', align: 'center', value: 'tempStopFlg', sortable: false, width: 105 },
        { text: '管理者', align: 'center', value: 'adminFlg', sortable: false, width: 80 }
      ]

      this.headers.accountEntry = [
        { text: '申請日時', value: 'mailAddress', sortable: false, width: 200 },
        { text: 'ID', value: 'entryDt', sortable: false },
        { text: '氏名', value: 'name', sortable: false, width: 300 },
        { text: '所属', value: 'groupName', sortable: false, width: 220 },
        { text: this.view.keywordLable.ja, value: 'companyName', sortable: false, width: 200 }
      ]
    },
    async setLabel () {
      const list = await Common.labelList({ key: 'account' })
      this.view.keywordLable.ja = this.getValueFromLabelList(list, 'label.account.keyword.ja')
    },
    getValueFromLabelList (list, key) {
      const ele = list.find(ele => ele.configKey === key)
      if (ele === undefined || ele.configVal === undefined) {
        return ''
      } else {
        return ele.configVal
      }
    }
  },
  created: async function () {
    await this.setLabel()
    this.setHeaders()
    const groupList = await Common.groupList()
    this.view.groupList = groupList
      .flatMap(groupLarge => groupLarge.groupSmallList
        .map(groupSmall => ({
          text: groupLarge.groupLargeName.ja + '＞' + groupSmall.groupSmallName.ja,
          value: groupSmall.groupSmallId
        })))

    this.companyInsNoGroupSmallIdList = groupList
      .filter(groupLarge => groupLarge.companyInsNoFlg === '1')
      .flatMap(groupLarge => groupLarge.groupSmallList
        .map(groupSmall => groupSmall.groupSmallId)
      )
  },
  watch: {
    'form.befor.groupSmallId': async function (groupSmallId) {
      await this.changeGroupSmall('befor', groupSmallId)
    },
    'form.after.groupSmallId': async function (groupSmallId) {
      await this.changeGroupSmall('after', groupSmallId)
    },
    'form.befor.companyId': async function (companyId) {
      await this.changeCompany('befor', companyId)
    },
    'form.after.companyId': async function (companyId) {
      await this.changeCompany('after', companyId)
    },
    'form.befor.branchId': async function (branchId) {
      if (this.form.befor.companyId !== null) {
        await this.goSearch()
      }
    }
  }
}
</script>
<style scoped>
  .v-icon.mdi-new-box {
    color: #E62233;
  }
</style>
